import React, { useEffect, useState } from "react";
import "./fun.css";
import axios from "axios";
import { apibaseurl } from "../../../../environment";

const FunNode = ({ node }) => {
  const [expanded, setExpanded] = useState(false);
  const hasChildren = node.children && node.children.length > 0;

  return (
    <li
      className={`org-node mt-4 ${hasChildren ? "has-children" : ""} ${
        expanded ? "expanded" : ""
      }`}
    >
      <div className="node">
        <div className="card">
          <div className="node-info">
            <h6 className="text-white">{node.name}</h6>
            <small>{node.title}</small>
          </div>
        </div>
        {hasChildren && (
          <span
            className={expanded ? "toggle-btnMinuse" : "toggle-btnPlus"}
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? "−" : "+"}
          </span>
        )}
      </div>

      {hasChildren && (
        <ul className={`children-wrapper ${expanded ? "expanded" : ""}`}>
          {node.children.map((child, idx) => (
            <FunNode key={idx} node={child} />
          ))}
        </ul>
      )}
    </li>
  );
};

const FunChart = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get(
        `${apibaseurl}/api/manager/functional-structure`,
        // "http://192.168.1.13:8989/api/manager/functional-structure"
        {
          headers: {
            Authorization:
              "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmdJZCI6InRlYW0xXzMyOTA5IiwicmVxSXAiOiI6OmZmZmY6MTkyLjE2OC4xLjE0IiwiZW1wbG95ZWVfaWQiOiJUMS0wMTIzIiwiaWF0IjoxNzUzOTYxNzkzfQ.pDMr2y5jMga2xHdxx3fC5Pps5zaNgPQquBdBciVhguw",
          },
        }
      )
      .then((res) => setData(res.data.data))
      .catch(console.error);
  }, []);

  return (
    <div className="fun-chart-wrapper" id="functional_chart">
      <div className="chart-parent" id="fun-chart">
        <div className="chart-container">
          <ul className="tree" style={{ padding: 0 }}>
            <FunNode node={data} />
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FunChart;
